
export const ICONS = {
    PREVIOUS: 'M256 896v-768h128v352l320-320v704l-320-320v352z',
    NEXT: 'M768 128v768h-128v-352l-320 320v-704l320 320v-352z',
    PLAY: 'M790.857 529.714l-758.857 421.714c-17.714 9.714-32 1.143-32-18.857v-841.143c0-20 14.286-28.571 32-18.857l758.857 421.714c17.714 9.714 17.714 25.714 0 35.429z',
    PAUSE: 'M877.714 109.714v804.571c0 20-16.571 36.571-36.571 36.571h-292.571c-20 0-36.571-16.571-36.571-36.571v-804.571c0-20 16.571-36.571 36.571-36.571h292.571c20 0 36.571 16.571 36.571 36.571zM365.714 109.714v804.571c0 20-16.571 36.571-36.571 36.571h-292.571c-20 0-36.571-16.571-36.571-36.571v-804.571c0-20 16.571-36.571 36.571-36.571h292.571c20 0 36.571 16.571 36.571 36.571z',
};

export const THEME = {
    FD: ['#4393ab', '#000', '#f4e1d2', '#000', '#fff', '#ffead9', "transparent"],
};
